<template>
    <BlocksBlockWrapper
        v-for="block in pageBlocks"
        :key="block.canonicalUid"
        :block="block"
    />
</template>

<script setup>
    const { entry } = storeToRefs(useEntryStore())

    const pageBlocks = computed(() => {
        return get(entry.value, 'contentBuilder', [])
    })

</script>
